export default {
  title: "Mandat administratif",
  signed: "Le mandat de représentation a été signé",
  "not-signed": {
    title: "Le mandat n’a pas été signé",
    description:
      "Le mandat doit encore être signé soit en copiant le lien et en l’envoyant au client, soir en téléchargent vous-même.",
  },
  sent: {
    title: "Le mandat a bien été envoyé",
    description:
      "Le mandat a été envoyé au client et est en attente de signature.",
  },
  "guidance-link": "Visualiser le mandat",
  "awaiting-signing": "En attente de la signature du mandat",
  "client-action": "Votre client doit signer le mandat",
  "copy-link": "Copier le lien électronique",
  "upload-mandate": "Télécharger le mandat papier",
  "share-mandate": "Partager lien du mandat électronique",
  "mandate-signed-at": "Le mandat a été signé le",
  view: "Afficher",
  update: "Mettre à jour",
  "refresh-params": "Mettre à jour les champs du mandat",
  "preview-title": "Mandat de représentation",
  "send-to-customer": "Envoyer mandat par email",
  "resend-mandate": "Renvoyer mandat par email",
  "edit-signature": "Accéder à la signature de l’entreprise",
  "add-signature": "Ajouter une signature",
  "self-admin-tooltip":
    "Il s'agit d'un mandat tripartite de Projetsolaire. En mode auto-administrateur, il est recommandé d'utiliser votre propre mandat pour garantir la pleine propriété des ventes.",
};
